import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { jwtDecode } from 'jwt-decode';
import { AuthService } from './services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private router:Router, private auth: AuthService){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): 
    Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (sessionStorage.getItem('token')) {
        let token:any = sessionStorage.getItem('token').slice(0, -4);
        
        let decode:any = jwtDecode(this.auth.removeInsertedString(token,'cb0212',3))
        var dateNow = Date.now()/1000;
        // console.log(decode.exp < dateNow)
        if(decode.exp < dateNow)
        {
          this.router.navigateByUrl('/login')
          return false;
        }
        else{
          // if(route['_urlSegment']['segments'][0].path == decode.type.toLowerCase())
            return true
          // else
          //   return false;
        }
      } else {
        this.router.navigateByUrl('/login')
        return false;
      }
  }
  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): 
    Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (sessionStorage.getItem('token')) {
        const expectedRole = route.data['expectedRole'];
        let token:any = sessionStorage.getItem('token').slice(0, -4);
        let decode:any = jwtDecode(token)
        var currentRole = decode.position;
        console.log(expectedRole)
        console.log(expectedRole.includes(currentRole))
        if(expectedRole.includes(currentRole))
        {
          this.router.navigateByUrl('/login')
          return false;
        }
        else{
            return true
        }
      } else {
        this.router.navigateByUrl('/login')
        return false;
      }
  }
  
}
